<div class="container col-lg-12 p-0">
    <div class="justify-content-between align-items-center">
        <h5 style="font-size: 15px;margin-bottom: 24px;margin-left: 24px">Utilisateurs et roles</h5>
        <div class="d-flex justify-content-between align-items-center content m-0">
            <div class="input-group form-password-toggle d-flex justify-self-start" style="max-width: 250px; min-width: 150px;margin: 24px">
                <input type="text"
                       class="form-control search-bar"
                       placeholder="Recherche par mot clé"
                       (input)="onSearch($event)">
                <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black; cursor: pointer; background-color: transparent; border-left: none; padding: 0 10px;">
                        <i data-feather="search" [size]="20"></i>
                    </span>
                </div>
            </div>
            <button class="btn btn-primary ajouter" (click)="addRole()">+ Ajouter</button>
        </div>
    </div>
</div>

<div class=" p-0" style="margin-left: 0; border: none;">
    <div class="card-body p-0" style="padding: 0;">
        <table class="table align-middle" style="margin-left: 0;">
            <thead class="custom-thead">
            <tr>
                <th style="text-transform: uppercase;">Utilisateur</th>
                <th style="text-transform: uppercase;">Listes d'entreprise</th>
                <th style="text-transform: uppercase;">Dernière connexion</th>
                <th style="text-transform: uppercase;">Statut</th>
                <th style="text-transform: uppercase;">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of filteredUsers" style="border-bottom: 1px solid #dee2e6;">
                <td class="align-middle">
                    <strong style="color: #2f2b3d;">{{ user.name }}</strong><br />
                    <span style="color: #6c757d; font-size: 14px;">{{ user.email }}</span>
                </td>
                <td class="align-middle">
                    <div class="d-flex align-items-center" style="min-height: 40px;">
                        <img *ngFor="let entreprise of user.entreprises.slice(0, 2)"
                             [src]="'../../../../assets/images/logo/logo.png'"
                             alt="Image"
                             style="width: 27px; height: auto; border-radius: 4px; margin-right: 8px;">
                        <span *ngIf="user.entreprises.length > 2"
                              class="badge bg-light text-dark"
                              style="font-size: 12px; padding: 4px 8px;">
                                +{{ user.entreprises.length - 2 }}
                            </span>
                    </div>
                </td>
                <td class="align-middle" style="color: #6c757d; font-size: 14px;">{{ user.lastConnection }}</td>
                <td class="align-middle">
                    <div class="custom-control custom-switch custom-control-success d-inline-block position-relative" style="margin:0;">
                        <input type="checkbox"
                               [id]="'customSwitch' + user.id"
                               class="custom-control-input"
                               [checked]="user.isActive"
                               [disabled]="isProcessingStatusChange"
                               (change)="toggleUserStatus(user.id, $event.target.checked)">
                        <label class="custom-control-label" [for]="'customSwitch' + user.id"></label>
                    </div>

                </td>
                <td class="align-middle">
                    <div class="d-flex" style="min-height: 40px; gap: 8px;">
                        <i data-feather="edit"
                           class="feather-icon"
                           [size]="20"
                           style="cursor: pointer; vertical-align: middle; line-height: 1; color: #134AD3;"
                           (click)="editUser()"
                         ></i>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>

<app-croud-liste-prix #croud></app-croud-liste-prix>

<ng-template #confirmationModal let-modal>
    <div class="modal-header d-flex flex-column align-items-center position-relative" style="background: transparent">
        <button type="button" class="close position-absolute" style="top: 1rem; right: 1rem; border: none; font-size: 1.5rem; font-weight: 700; color: #6c757d;" (click)="closeConfirmationModal()" aria-label="Close">
            <span aria-hidden="true">×</span>
        </button>
    </div>

    <div class="modal-body text-center p-0" style="margin:42px 64px 64px">
        <h4 class="modal-title font-weight-bold" style="font-size: 24px; color:rgba(47, 43, 61, 0.9);margin-bottom:8px; font-weight: 500">
            {{ actionType === 'activate' ? 'Activation utilisateur' : 'Désactivation utilisateur' }}
        </h4>
        <p style="font-size: 15px; color:rgba(47, 43, 61, 0.7);margin-bottom: 24px; line-height: 1.5;">
            Êtes-vous sûr de vouloir {{ actionType === 'activate' ? 'activer' : 'désactiver' }} l'utilisateur
            <strong style="color: rgba(47, 43, 61, 0.9);">{{ currentUser?.name }}</strong> ?
        </p>
        <div class="d-flex justify-content-center gap-3">
            <button type="button"
                    class="btn btn-primary"

                    style="min-width: 100px; padding: 8px 20px; border-radius: 6px;margin-right: 16px"
                    [disabled]="isProcessingStatusChange"
                    (click)="confirmStatusChange()">

                {{ actionType === 'activate' ? 'Activer' : 'Désactiver' }}
            </button>
            <button type="button"
                    class="btn"
                    (click)="closeConfirmationModal()"
                    style="background: rgba(128, 131, 144, 0.16); color: #6c757d; border: 1px solid #dee2e6; padding: 8px 20px; border-radius: 6px;"
                    [disabled]="isProcessingStatusChange">
                Annuler
            </button>
        </div>
    </div>
</ng-template>
